// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.replay__PegMP {
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 30px;
  padding: 8px 20px;

  font-size: 14px;

  background: white;
  border-top: 1px solid #f3f3f3;
}

.replay__PegMP > div {
  display: flex;
  align-items: center;
}

.replayContentWrapper__mhEvM {
  display: flex;
  width: 270px;
}

.replayImg__XTsKW {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

.replayFile__hfBI7,
.replayImg__XTsKW {
  margin-left: 8px;
}

.replayText__YXAhW {
  overflow: hidden;
  display: inline-block;

  margin-left: 8px;

  font-size: 16px;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.removeButton__E18XO {
  cursor: pointer;

  margin-left: 8px;
  padding: 0;

  background: none;
  border: none;
}

.removeButton__E18XO:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatInput/Replay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,YAAY;EACZ,iBAAiB;;EAEjB,eAAe;;EAEf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;;EAErB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,gBAAgB;EAChB,UAAU;;EAEV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".replay {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  height: 30px;\n  padding: 8px 20px;\n\n  font-size: 14px;\n\n  background: white;\n  border-top: 1px solid #f3f3f3;\n}\n\n.replay > div {\n  display: flex;\n  align-items: center;\n}\n\n.replayContentWrapper {\n  display: flex;\n  width: 270px;\n}\n\n.replayImg {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n}\n\n.replayFile,\n.replayImg {\n  margin-left: 8px;\n}\n\n.replayText {\n  overflow: hidden;\n  display: inline-block;\n\n  margin-left: 8px;\n\n  font-size: 16px;\n  line-height: 22px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.removeButton {\n  cursor: pointer;\n\n  margin-left: 8px;\n  padding: 0;\n\n  background: none;\n  border: none;\n}\n\n.removeButton:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var replay = `replay__PegMP`;
export var replayContentWrapper = `replayContentWrapper__mhEvM`;
export var replayImg = `replayImg__XTsKW`;
export var replayFile = `replayFile__hfBI7`;
export var replayText = `replayText__YXAhW`;
export var removeButton = `removeButton__E18XO`;
export default ___CSS_LOADER_EXPORT___;
